import { FIREBASE_API } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AgChartOptions } from 'ag-charts-community';
import { Logger } from '@app/core/logger.service';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { SearchPostClickMeetingComponent } from '../search-post-click-meeting/search-post-click-meeting.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as XLSX from 'xlsx';
const log = new Logger('DetailClickMeetingComponent');
@Component({
  selector: 'app-detail-click-meeting',
  templateUrl: './detail-click-meeting.component.html',
  styleUrls: ['./detail-click-meeting.component.scss'],
})
export class DetailClickMeetingComponent implements OnInit {
  item: any;
  item2: any;
  confirmationList: any[] = [];
  assistanceList: any[] = [];
  postUid: string | null = null;
  postDetails: any = null;
  summaryChartOptions: AgChartOptions | undefined;
  private specialtyCatalog: Record<string, string> = {};
  private specialtyCatalogLoaded = false;
  private readonly mexicanStates = [
    'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas', 'Chihuahua',
    'Ciudad de México', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo',
    'Jalisco', 'México', 'Michoacán', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
    'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
    'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
  ];

  readonly confirmationExportFields = [
    { key: 'uid', label: 'UID' },
    { key: 'email', label: 'Email' },
    { key: 'nameStr', label: 'Nombre' },
    { key: 'type', label: 'Tipo' },
    { key: 'mobile', label: 'Celular' },
    { key: 'phone', label: 'Teléfono' },
    // { key: 'filter-meta-data', label: 'filter-meta-data' },
    { key: 'especialidad', label: 'Especialidad' },
    { key: 'estado', label: 'Estado' }
  ];
  readonly assistanceExportFields = [
    { key: 'uid', label: 'UID' },
    { key: 'email', label: 'Email' },
    { key: 'nameStr', label: 'Nombre' },
    { key: 'type', label: 'Tipo' },
    { key: 'mobile', label: 'Celular' },
    { key: 'phone', label: 'Teléfono' },
    { key: 'duration', label: 'Tiempo de permanencia' },
    //  { key: 'filter-meta-data', label: 'filter-meta-data' },
    { key: 'especialidad', label: 'Especialidad' },
    { key: 'estado', label: 'Estado' },
    { key: '__guestStatus', label: 'Invitado' }
  ];

  constructor(
    private afs: AngularFirestore,
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private http: HttpClient,
    private loadingCtrl: LoadingController
  ) { }

  ngOnInit() {
    this.initializeData();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async initializeData() {
    const loading = await this.loadingCtrl.create({ message: 'Cargando...' });
    loading.present();
    try {
      await this.loadSpecialtiesCatalog();
      await this.confirmations();
      await this.attendees();
      this.loadSummaryChart();
    } catch (error) {
      log.error(error);
    }
    loading.dismiss();
  }

  async confirmations() {
    try {
      if (this.item2 && this.item2.id) {
        const id = await this.getPostIdByRoomId(String(this.item2.id));
        if (id) {
          this.postUid = id;
          await this.loadPostDetails(id);
          const postRef = this.afs.doc(`posts/${id}`);
          const postDoc = await postRef.ref.get();
          const postData = (postDoc.exists ? postDoc.data() : {}) as any;
          const confirmationRef = this.afs.collection(`posts/${id}/confirmaciones`);
          const confirmationSnap = await confirmationRef.ref.get();

          if (postData?.confirmationsMapped === true && !confirmationSnap.empty) {
            this.confirmationList = confirmationSnap.docs.map((doc: any) => ({ id: doc.id, ...doc.data() }));
            return;
          }

          const fallbackSnap = confirmationSnap.empty
            ? await this.afs.collection(`posts/${id}/assistance`).ref.get()
            : null;
          const docs = confirmationSnap.empty ? (fallbackSnap?.docs || []) : confirmationSnap.docs;
          const confirmations = await Promise.all(
            docs.map(async (e: any) => {
              const data: any = e.data();
              const userId: string = e.id;
              const userDoc = await this.afs.collection('users').doc(userId).ref.get();
              const userData = (userDoc.exists ? userDoc.data() : {}) as any;
              const metadataInfo = this.normalizeFilterMetaDataValue(userData?.['filter-meta-data'], data?.['filter-meta-data']);
              const metadataFilter = metadataInfo.values;
              const mappedData = {
                id: userId,
                ...data,
                uid: userDoc.exists ? userDoc.id : userId,
                type: userData?.type || data?.type || 'N/A',
                email: userData?.email || data?.email || 'N/A',
                nameStr: userData?.nameStr || userData?.name || data?.name || 'N/A',
                mobile: userData?.mobile || data?.mobile || 'N/A',
                status: userData?.status || data?.status || 'N/A',
                phone: userData?.phone || data?.phone || 'N/A',
                'filter-meta-data': metadataFilter,
                estado: metadataInfo.state || data?.estado || '',
                especialidad: metadataInfo.specialtyName || data?.especialidad || metadataInfo.specialtyId || '',
                especialidadId: metadataInfo.specialtyId || data?.especialidadId || '',
                mapped: true,
                mappedAt: new Date(),
                mappingSource: 'users'
              };

              if (data?.mapped !== true || !data?.email || !data?.nameStr || !data?.type || metadataFilter.length === 0 || !data?.estado || !data?.especialidad) {
                await confirmationRef.doc(userId).set(mappedData, { merge: true });
              }

              return mappedData;
            })
          );

          this.confirmationList = confirmations;
          if (!postData?.confirmationsMapped) {
            await postRef.set({
              confirmationsMapped: true,
              confirmationsMappingStatus: 'mapped',
              confirmationsMappedAt: new Date()
            }, { merge: true });
          }
        } else {
          await this.alertNotFoundPost(this.item2.id);
        }
      }
    } catch (error) {
      log.error(error);
    }
  }

  async attendees() {
    try {
      if (this.item && this.item.conference && this.item.conference.id && this.item2 && this.item2.id) {
        const id = await this.getPostIdByRoomId(String(this.item2.id));
        if (!id) {
          return;
        }

        this.postUid = id;
        await this.loadPostDetails(id);
        const attendeesRef = this.afs.collection(`posts/${id}/asistencias`);
        const postRef = this.afs.doc(`posts/${id}`);
        const postDoc = await postRef.ref.get();
        const postData = (postDoc.exists ? postDoc.data() : {}) as any;
        const attendeesSnap = await attendeesRef.ref.get();
        const fallbackAttendeesSnap = attendeesSnap.empty
          ? await this.afs.collection(`posts/${id}/attendees`).ref.get()
          : null;
        const attendanceDocs = attendeesSnap.empty ? (fallbackAttendeesSnap?.docs || []) : attendeesSnap.docs;
        const hasPersistedAttendees = attendanceDocs.some((doc: any) => doc.data()?.mapped === true);
        const needsMetadataSync = attendanceDocs.some((doc: any) => {
          const metadata = this.getFilterMetaDataValue(doc.data()?.['filter-meta-data']);
          return doc.data()?.mapped === true && metadata.length === 0;
        });

        if (attendanceDocs.length > 0) {
          if (postData?.attendeesMapped === true) {
            this.assistanceList = attendanceDocs.map((doc: any) => ({ id: doc.id, ...doc.data() }));
            return;
          }

          const mappedAttendees = await Promise.all(attendanceDocs.map(async (doc: any) => {
            const docData = doc.data() || {};
            const normalizedData = this.normalizePersistedRecord(docData);
            if (this.shouldUpdatePersistedRecord(docData, normalizedData)) {
              await attendeesRef.doc(doc.id).set(normalizedData, { merge: true });
            }
            return { id: doc.id, ...normalizedData };
          }));

          this.assistanceList = mappedAttendees;
          await postRef.set({
            attendeesMapped: true,
            attendeesMappingStatus: 'mapped',
            attendeesMappedAt: new Date()
          }, { merge: true });
          return;
        }

        const conferenceId = this.item.conference.id;
        const sessionId = this.item2.id;
        const metadataFilter = this.getFilterMetaDataValue(postData?.['filter-meta-data'], this.item?.['filter-meta-data'], this.item2?.['filter-meta-data']);
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        const resp: any = await this.http
          .post(`${FIREBASE_API}getClickMeetingAttendees`, { conferenceId: conferenceId, sessionId: sessionId, 'filter-meta-data': metadataFilter }, { headers: headers })
          .toPromise();
        const attendees = Array.isArray(resp?.response) ? resp.response : [];

        const mappedAttendees = await Promise.all(attendees.map(async (attendee: any, index: number) => {
          const attendeeId = attendee.id || attendee.uid || attendee.userId || `${attendee.email || attendee.nickname || 'attendee'}-${index}`;
          const normalizedEmail = attendee.email || attendee.mail || '';
          let userData: any = {};
          let userUid = attendeeId;

          if (attendee.uid) {
            const userDocById = await this.afs.collection('users').doc(attendee.uid).ref.get();
            if (userDocById.exists) {
              userData = userDocById.data() || {};
              userUid = userDocById.id;
            }
          }

          if (!userData?.email && normalizedEmail) {
            const userQuery = await this.afs.collection('users').ref.where('email', '==', normalizedEmail).limit(1).get();
            if (!userQuery.empty) {
              userData = userQuery.docs[0].data() || {};
              userUid = userQuery.docs[0].id;
            }
          }

          const metadataInfo = this.normalizeFilterMetaDataValue(userData?.['filter-meta-data'], attendee?.['filter-meta-data']);
          const metadataFilter = metadataInfo.values;
          const mappedAttendee = {
            id: attendeeId,
            ...attendee,
            uid: userUid,
            email: userData?.email || attendee.email || attendee.mail || 'N/A',
            nickname: userData?.nameStr || userData?.name || attendee.nickname || attendee.name || attendee.nameStr || 'N/A',
            nameStr: userData?.nameStr || userData?.name || attendee.nameStr || attendee.name || attendee.nickname || 'N/A',
            type: userData?.type || attendee.type || 'N/A',
            mobile: userData?.mobile || attendee.mobile || 'N/A',
            status: userData?.status || attendee.status || 'N/A',
            phone: userData?.phone || attendee.phone || 'N/A',
            'filter-meta-data': metadataFilter,
            estado: metadataInfo.state || attendee?.estado || '',
            especialidad: metadataInfo.specialtyName || attendee?.especialidad || metadataInfo.specialtyId || '',
            especialidadId: metadataInfo.specialtyId || attendee?.especialidadId || '',
            mapped: true,
            mappedAt: new Date(),
            mappingSource: 'http'
          };

          await attendeesRef.doc(attendeeId).set(mappedAttendee, { merge: true });
          return mappedAttendee;
        }));

        this.assistanceList = mappedAttendees;

        await postRef.set({
          attendeesMapped: true,
          attendeesMappingStatus: 'mapped',
          attendeesMappedAt: new Date()
        }, { merge: true });
      }
    } catch (error) {
      log.error(error);
    }
  }

  loadSummaryChart() {
    const confirmedCount = this.confirmationList.length;
    const assistanceCount = this.assistanceList.length;
    this.summaryChartOptions = {
      autoSize: true,
      title: {
        text: 'Confirmaciones vs Asistentes',
        fontSize: 14,
        color: '#1a1a1a'
      },
      data: [
        { category: 'Confirmaciones', value: confirmedCount },
        { category: 'Asistentes', value: assistanceCount }
      ],
      series: [
        {
          type: 'column',
          xKey: 'category',
          yKey: 'value',
          yName: 'Total',
          fill: '#387fff',
          stroke: '#2557d5',
          tooltip: {
            renderer: ({ datum }) => ({
              content: `${datum.category}: ${datum.value}`
            })
          }
        }
      ],
      axes: [
        {
          type: 'category',
          position: 'bottom',
          label: {
            rotation: 0,
            fontSize: 12
          }
        },
        {
          type: 'number',
          position: 'left',
          label: {
            formatter: ({ value }) => `${value}`
          }
        }
      ],
      legend: {
        enabled: false
      },
      padding: {
        top: 16,
        right: 16,
        bottom: 24,
        left: 16
      }
    };
  }

  private async loadPostDetails(postId: string) {
    try {
      const postDoc = await this.afs.doc(`posts/${postId}`).ref.get();
      const postData = (postDoc.exists ? postDoc.data() : {}) as any;
      this.postDetails = {
        uid: postDoc?.id || '',
        title: postData?.title || postData?.name || 'Sin título',
        image: postData?.image || postData?.imageUrl || postData?.imageBG || postData?.featuredImage || postData?.cover || postData?.coverImage || null,
        publication_date: postData?.publication_date || postData?.date || postData?.createdAt || null
      };
    } catch (error) {
      log.error(error);
      this.postDetails = null;
    }
  }

  private async getPostIdByRoomId(roomId: string): Promise<string | undefined> {
    const resp = await this.afs.collection('posts').ref.where('roomId', '==', roomId).orderBy('publication_date', 'desc').get();
    const ids = resp.docs.map(e => e.id);
    return ids && ids.length > 0 ? ids[0] : undefined;
  }

  async alertNotFoundPost(id: string) {
    const alert = await this.alertController.create({
      header: `No se encontró la publicación`,
      message: `No se encontró la publicación correspondiente a la sala: ${id}, ¿Desea selecionarla Manualmente?`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Seleccionar manualmente',
          cssClass: 'secondary',
          handler: () => {
            this.searchPost();
          }
        }
      ]
    });
    await alert.present();
  }

  async searchPost() {
    try {
      const modal = await this.modalCtrl.create({
        component: SearchPostClickMeetingComponent,
        componentProps: {
          item: this.item,
          item2: this.item2
        }
      });
      modal.onDidDismiss().then(async (data) => {
        if (data && data.data && data.data.selectedPostId) {
          this.initializeData();
        }
      });
      await modal.present();
    } catch (error) {
      log.error(error);
    }
  }

  async exportReport(kind: 'confirmations' | 'assistants') {
    try {
      const source = kind === 'confirmations' ? this.confirmationList : this.assistanceList;
      const fields = kind === 'confirmations' ? this.confirmationExportFields : this.assistanceExportFields;

      if (!source || source.length === 0) {
        await this.presentAlert('Sin datos', 'No hay información para exportar en este reporte.');
        return;
      }

      const rows = source.map((item: any) => {
        const normalized: any = {};
        fields.forEach((field: any) => {
          const key = typeof field === 'string' ? field : field.key;
          const label = typeof field === 'string' ? field : field.label;
          const value = this.getExportValue(item, key);
          normalized[label] = value;
        });
        return normalized;
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, kind === 'confirmations' ? 'Confirmaciones' : 'Asistentes');
      const sessionName = this.getExportSessionName();
      const fileName = `${kind === 'confirmations' ? 'confirmaciones' : 'asistencias'}-${sessionName}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      log.error(error);
      await this.presentAlert('Error', 'No se pudo generar el archivo Excel.');
    }
  }

  private getExportValue(item: any, path: string) {
    if (path === '__guestStatus') {
      const hasUserRecord = Boolean(item?.email && item?.nameStr && item?.type && item?.type !== 'N/A');
      return hasUserRecord ? '' : 'Invitado';
    }

    const value = path.split('.').reduce((acc: any, key: string) => acc?.[key], item);
    if (Array.isArray(value)) {
      return value.map((entry: any) => typeof entry === 'string' ? entry : JSON.stringify(entry)).join(', ');
    }
    if (value instanceof Date) {
      return value.toISOString();
    }
    if (value && typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value ?? '';
  }

  private getExportSessionName(): string {
    const sessionName = this.item?.name
      || this.item?.title
      || this.item?.sessionName
      || this.item?.conference?.name
      || this.item2?.name
      || this.item2?.title
      || this.item2?.sessionName
      || 'sesion-virtual';

    return String(sessionName)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '') || 'sesion-virtual';
  }

  private async loadSpecialtiesCatalog() {
    if (this.specialtyCatalogLoaded) {
      return;
    }

    try {
      const snapshot = await this.afs.collection('specialties').ref.get();
      this.specialtyCatalog = {};
      snapshot.docs.forEach((doc: any) => {
        const data = (doc.data() || {}) as any;
        const docId = String(doc.id || '').trim();
        const name = String(data?.name || data?.specialtyName || '').trim();
        if (docId) {
          this.specialtyCatalog[this.normalizeValue(docId)] = name;
        }
        if (name) {
          this.specialtyCatalog[this.normalizeValue(name)] = name;
        }
      });
      this.specialtyCatalogLoaded = true;
    } catch (error) {
      log.error(error);
      this.specialtyCatalogLoaded = true;
    }
  }

  private normalizeValue(value: any): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  private getFilterMetaDataValue(...sources: any[]): any[] {
    for (const source of sources) {
      if (Array.isArray(source)) {
        const values = source.filter((value: any) => value !== undefined && value !== null && value !== '');
        if (values.length > 0) {
          return values;
        }
      }

      if (typeof source === 'string' && source.trim()) {
        return [source];
      }

      if (source && typeof source === 'object') {
        const nested = source['filter-meta-data'] || source.filterMetaData || source.filter_meta_data;
        const normalized = this.getFilterMetaDataValue(nested);
        if (normalized.length > 0) {
          return normalized;
        }
      }
    }

    return [];
  }

  private normalizeFilterMetaDataValue(...sources: any[]): { values: any[]; state: string; specialtyId: string; specialtyName: string } {
    const rawValues = this.getFilterMetaDataValue(...sources);
    const cleanedValues: string[] = [];
    let state = '';
    let specialtyId = '';
    let specialtyName = '';

    rawValues.forEach((value: any) => {
      const text = String(value ?? '').trim();
      if (!text) {
        return;
      }

      const stateName = this.extractStateName(text);
      if (stateName) {
        state = state || stateName;
        return;
      }

      const specialtyCandidate = this.extractSpecialtyCandidate(text);
      if (specialtyCandidate) {
        specialtyId = specialtyId || specialtyCandidate;
        return;
      }

      const fallbackState = this.getKnownStateName(text);
      if (fallbackState) {
        state = state || fallbackState;
        return;
      }
    });

    if (state) {
      cleanedValues.push(state);
    }

    if (specialtyId) {
      cleanedValues.push(specialtyId);
    }

    if (specialtyId) {
      specialtyName = this.getSpecialtyName(specialtyId) || '';
    }

    return {
      values: cleanedValues,
      state,
      specialtyId,
      specialtyName
    };
  }

  private extractStateName(value: string): string {
    const normalizedValue = this.normalizeValue(value);
    if (!normalizedValue) {
      return '';
    }

    const exactMatch = this.mexicanStates.find((state: string) => this.normalizeValue(state) === normalizedValue);
    if (exactMatch) {
      return exactMatch;
    }

    const partialMatch = this.mexicanStates.find((state: string) => {
      const normalizedState = this.normalizeValue(state);
      return normalizedValue.includes(normalizedState) || normalizedState.includes(normalizedValue);
    });
    if (partialMatch) {
      return partialMatch;
    }

    const valueTokens = normalizedValue.split(/[^a-z0-9]+/).filter(Boolean);
    const tokenMatch = this.mexicanStates.find((state: string) => {
      const normalizedState = this.normalizeValue(state);
      const stateTokens = normalizedState.split(/[^a-z0-9]+/).filter(Boolean);
      return stateTokens.some((token: string) => valueTokens.includes(token));
    });

    return tokenMatch || '';
  }

  private getKnownStateName(value: string): string {
    const normalizedValue = this.normalizeValue(value);
    const directMatch = this.mexicanStates.find((state: string) => this.normalizeValue(state) === normalizedValue);
    return directMatch || '';
  }

  private extractSpecialtyCandidate(value: string): string {
    const normalizedValue = this.normalizeValue(value);
    const directSpecialtyMatch = this.specialtyCatalog[normalizedValue];
    if (directSpecialtyMatch) {
      return value.trim();
    }

    const numericMatch = value.match(/\d+/);
    if (numericMatch) {
      return numericMatch[0];
    }

    if (value && value.length >= 3) {
      const alphanumeric = value.replace(/[^A-Za-z0-9]/g, '').trim();
      if (alphanumeric && alphanumeric.length >= 3) {
        return alphanumeric;
      }
    }

    return '';
  }

  private getSpecialtyName(specialtyId: string): string {
    if (!specialtyId) {
      return '';
    }

    const normalizedId = this.normalizeValue(specialtyId);
    return this.specialtyCatalog[normalizedId] || '';
  }

  private normalizePersistedRecord(record: any) {
    const metadataInfo = this.normalizeFilterMetaDataValue(record?.['filter-meta-data']);
    return {
      ...record,
      'filter-meta-data': metadataInfo.values,
      estado: metadataInfo.state || record?.estado || '',
      especialidad: metadataInfo.specialtyName || record?.especialidad || metadataInfo.specialtyId || '',
      especialidadId: metadataInfo.specialtyId || record?.especialidadId || ''
    };
  }

  private shouldUpdatePersistedRecord(docData: any, normalizedData: any): boolean {
    if (!docData?.estado || !docData?.especialidad || !docData?.especialidadId) {
      return true;
    }

    if (!this.arraysEqual(docData?.['filter-meta-data'], normalizedData['filter-meta-data'])) {
      return true;
    }

    if (docData?.estado !== normalizedData.estado || docData?.especialidad !== normalizedData.especialidad || docData?.especialidadId !== normalizedData.especialidadId) {
      return true;
    }

    return false;
  }

  private arraysEqual(a: any, b: any): boolean {
    if (a === b) {
      return true;
    }
    if (!Array.isArray(a) || !Array.isArray(b)) {
      return false;
    }
    if (a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i += 1) {
      if (!this.valuesEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }

  private valuesEqual(a: any, b: any): boolean {
    if (a === b) {
      return true;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
      return this.arraysEqual(a, b);
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
      const aKeys = Object.keys(a);
      const bKeys = Object.keys(b);
      if (aKeys.length !== bKeys.length) {
        return false;
      }
      return aKeys.every((key) => this.valuesEqual(a[key], b[key]));
    }
    return false;
  }

  private async presentAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['Aceptar']
    });
    await alert.present();
  }

}
